// Concurrency adjustment with hysteresis to avoid rapid oscillations.
const clampNumber = (value, min, max) => Math.min(max, Math.max(min, value));

const getThresholdForLevel = (level, thresholds) => {
  if (level <= 1) {
    return null;
  }
  const idx = level - 2;
  if (idx < 0 || idx >= thresholds.length) {
    return null;
  }
  return thresholds[idx];
};

const targetFromSpeed = (avgMbps, thresholds, maxLimit) => {
  let target = 1;
  for (const threshold of thresholds) {
    if (avgMbps >= threshold) {
      target += 1;
    }
  }
  return clampNumber(target, 1, maxLimit);
};

const adjustConcurrencyWithHysteresis = ({
  avgMbps,
  currentLimit,
  maxLimit,
  thresholds,
  upPct,
  downPct
}) => {
  const maxSafe = clampNumber(maxLimit, 1, maxLimit);
  let nextLimit = clampNumber(currentLimit, 1, maxSafe);
  const baseTarget = targetFromSpeed(avgMbps, thresholds, maxSafe);

  const upThreshold = getThresholdForLevel(nextLimit + 1, thresholds);
  const downThreshold = getThresholdForLevel(nextLimit, thresholds);

  if (
    upThreshold != null &&
    baseTarget > nextLimit &&
    avgMbps >= upThreshold * (1 + upPct)
  ) {
    nextLimit = clampNumber(nextLimit + 1, 1, maxSafe);
  } else if (
    downThreshold != null &&
    baseTarget < nextLimit &&
    avgMbps <= downThreshold * (1 - downPct)
  ) {
    nextLimit = clampNumber(nextLimit - 1, 1, maxSafe);
  }

  return nextLimit;
};

export { adjustConcurrencyWithHysteresis };
